/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@ngx-translate/core/src/translate.pipe';
import * as import2 from '@ngx-translate/core/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from '@angular/router';
import * as import5 from '../../../app/company-select/company-select.component';
import * as import6 from '../../../app/services/company.service';
import * as import7 from '../../../app/services/local-storage.service';
import * as import8 from '../../../app/services/breadcrumbs.service';
import * as import9 from 'angular2-notifications/src/notifications.service';
const styles_CompanySelectComponent:any[] = [
  '.select-company-page[_ngcontent-%COMP%] { margin: 0 auto; text-align:center; width: 760px; }',
  ''
]
;
export const RenderType_CompanySelectComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 0,
  styles: styles_CompanySelectComponent,
  data: {}
}
);
function View_CompanySelectComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[[
        'class',
        'btn btn-small'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.changeCompany(v.context.$implicit.id)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,8,0,import0.ɵnov(v,9).transform('GENERAL.COMPANY.SELECT'));
    ck(v,8,0,currVal_1);
  });
}
function View_CompanySelectComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'section',[[
        'class',
        'select-company-page'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n      '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'table-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n          '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CompanySelectComponent_2)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n          '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.companies;
    ck(v,13,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('GENERAL.COMPANY.SELECT_DESC'));
    ck(v,3,0,currVal_0);
  });
}
function View_CompanySelectComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'section',[
      [
        'class',
        'select-company-page'
      ]
      ,
      [
        'style',
        'margin-top:200px'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'alt',
        'Company'
      ]
      ,
      [
        'src',
        '../../assets/images/icons/company.png'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n      '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'style',
        'color: #cccccc'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak zdefiniowanych firm'])),
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'routerLink',
        '/company/add'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,8).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import4.RouterLinkWithHref,[
      import4.Router,
      import4.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['DODAJ FIRMĘ'])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = '/company/add';
    ck(v,8,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,8).target;
    const currVal_1:any = import0.ɵnov(v,8).href;
    ck(v,7,0,currVal_0,currVal_1);
  });
}
export function View_CompanySelectComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'main',[[
        'class',
        'main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CompanySelectComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CompanySelectComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n  '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.CompanySelectComponent = v.component;
    const currVal_0:any = ((co.companies == null)? (null as any): co.companies.length);
    ck(v,5,0,currVal_0);
    const currVal_1:boolean = !((co.companies == null)? (null as any): co.companies.length);
    ck(v,8,0,currVal_1);
  },(null as any));
}
function View_CompanySelectComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-main',([] as any[]),(null as any),(null as any),(null as any),View_CompanySelectComponent_0,RenderType_CompanySelectComponent)),
    import0.ɵdid(114688,(null as any),0,import5.CompanySelectComponent,[
      import6.CompanyService,
      import7.LocalStorageService,
      import8.BreadcrumbsService,
      import9.NotificationsService,
      import4.Router
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const CompanySelectComponentNgFactory:import0.ComponentFactory<import5.CompanySelectComponent> = import0.ɵccf('app-main',import5.CompanySelectComponent,View_CompanySelectComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/company-select/company-select.component.ngfactory.ts